import { SharedTypes, ValidationRules, AttributeInputTypes, AttributeIcons, FormulaTypes, ContainerTypes, ContainerLayouts, VerticalAlignments, HorizontalAlignments } from '../enums';

export const getAllAttributeInputTypes = () => {
    return [
        { id: 1, name: AttributeInputTypes.HEADING },
        { id: 2, name: AttributeInputTypes.SUB_HEADING },
        { id: 3, name: AttributeInputTypes.STATIC_TEXT },
        { id: 4, name: AttributeInputTypes.INPUT_TEXT },
        { id: 5, name: AttributeInputTypes.NUMBER },
        { id: 6, name: AttributeInputTypes.LONG_INPUT_TEXT },
        { id: 7, name: AttributeInputTypes.DATE },
        { id: 8, name: AttributeInputTypes.DROP_DOWN },
        { id: 9, name: AttributeInputTypes.MULTI_DROP_DOWN },
        { id: 10, name: AttributeInputTypes.RADIO },
        { id: 11, name: AttributeInputTypes.CHECKBOX },
        { id: 12, name: AttributeInputTypes.DURATION },
    ];
};

export const getAttributeInputType = (id) => {
    switch (parseInt(id)) {
        case 1:
            return AttributeInputTypes.HEADING;
        case 2:
            return AttributeInputTypes.SUB_HEADING;
        case 3:
            return AttributeInputTypes.STATIC_TEXT;
        case 4:
            return AttributeInputTypes.INPUT_TEXT;
        case 5:
            return AttributeInputTypes.NUMBER;
        case 6:
            return AttributeInputTypes.LONG_INPUT_TEXT;
        case 7:
            return AttributeInputTypes.DATE;
        case 8:
            return AttributeInputTypes.DROP_DOWN;
        case 9:
            return AttributeInputTypes.MULTI_DROP_DOWN;
        case 10:
            return AttributeInputTypes.RADIO;
        case 11:
            return AttributeInputTypes.CHECKBOX;
        case 12:
            return AttributeInputTypes.DURATION;
    }
};

export const getAllAttributeIcons = () => {
    return [
        { id: 1, value: AttributeIcons.ICON_1, name: 'Icon 1' },
        { id: 2, value: AttributeIcons.ICON_2, name: 'Icon 2' },
        { id: 3, value: AttributeIcons.ICON_3, name: 'Icon 3' },
        { id: 4, value: AttributeIcons.ICON_4, name: 'Icon 4' },
        { id: 5, value: AttributeIcons.ICON_5, name: 'Icon 5' },
        { id: 6, value: AttributeIcons.ICON_6, name: 'Icon 6' },
        { id: 7, value: AttributeIcons.ICON_7, name: 'Icon 7' },
        { id: 8, value: AttributeIcons.ICON_8, name: 'Icon 8' },
        { id: 9, value: AttributeIcons.ICON_9, name: 'Icon 9' },
        { id: 10, value: AttributeIcons.ICON_10, name: 'Icon 10' },
        { id: 11, value: AttributeIcons.ICON_11, name: 'Icon 11' },
        { id: 12, value: AttributeIcons.ICON_12, name: 'Icon 12' },
        { id: 13, value: AttributeIcons.ICON_13, name: 'Icon 13' },
        { id: 14, value: AttributeIcons.ICON_14, name: 'Icon 14' },
        { id: 15, value: AttributeIcons.ICON_15, name: 'Icon 15' },
        { id: 16, value: AttributeIcons.ICON_16, name: 'Icon 16' },
        { id: 17, value: AttributeIcons.ICON_17, name: 'Icon 17' },
        { id: 18, value: AttributeIcons.ICON_18, name: 'Icon 18' },
        { id: 19, value: AttributeIcons.ICON_19, name: 'Icon 19' },
        { id: 20, value: AttributeIcons.ICON_20, name: 'Icon 20' },
        { id: 21, value: AttributeIcons.ICON_21, name: 'Icon 21' },
        { id: 22, value: AttributeIcons.ICON_22, name: 'Icon 22' },
        { id: 23, value: AttributeIcons.ICON_23, name: 'Icon 23' },
        { id: 24, value: AttributeIcons.ICON_24, name: 'Icon 24' },
        { id: 25, value: AttributeIcons.ICON_25, name: 'Icon 25' },
        { id: 26, value: AttributeIcons.ICON_26, name: 'Icon 26' },
        { id: 27, value: AttributeIcons.ICON_27, name: 'Icon 27' },
        { id: 28, value: AttributeIcons.ICON_28, name: 'Icon 28' },
        { id: 29, value: AttributeIcons.ICON_29, name: 'Icon 29' },
        { id: 30, value: AttributeIcons.ICON_30, name: 'Icon 30' },
        { id: 31, value: AttributeIcons.ICON_31, name: 'Icon 31' },
        { id: 32, value: AttributeIcons.ICON_32, name: 'Icon 32' },
        { id: 33, value: AttributeIcons.ICON_33, name: 'Icon 33' },
    ];
};

export const getFormulaTypes = () => {
    return [
        { id: 1, name: 'Boolean', value: FormulaTypes.BOOLEAN },
        { id: 2, name: 'Value', value: FormulaTypes.VALUE },
    ];
};

export const getFormulaType = (id) => {
    switch (parseInt(id)) {
        case 1:
            return FormulaTypes.BOOLEAN;
        case 2:
            return FormulaTypes.VALUE;
    }
};

export const getSharedTypes = () => {
    return [
        { id: 1, name: SharedTypes.SHARED },
        { id: 2, name: SharedTypes.COMPANY },
    ];
};

export const getSharedType = (id) => {
    switch (parseInt(id)) {
        case 1:
            return SharedTypes.SHARED;
        case 2:
            return SharedTypes.COMPANY;
    }
};

export const getAllContainerTypes = () => {
    return [
        { id: 1, value: ContainerTypes.COVER_1, name: 'Cover 1' },
        { id: 2, value: ContainerTypes.COVER_2, name: 'Cover 2' },
        { id: 3, value: ContainerTypes.COVER_3, name: 'Cover 3' },
        { id: 4, value: ContainerTypes.COVER_4, name: 'Cover 4' },
        { id: 5, value: ContainerTypes.MAIN, name: 'Main' },
        { id: 6, value: ContainerTypes.CONTAINER, name: 'Container' },
        { id: 7, value: ContainerTypes.TEXT, name: 'Text' },
        { id: 8, value: ContainerTypes.OL, name: 'Ordered List' },
        { id: 9, value: ContainerTypes.UL, name: 'Unordered list' },
        { id: 10, value: ContainerTypes.IMAGE, name: 'Image' },
        { id: 11, value: ContainerTypes.GRAPH, name: 'Graph' },
        { id: 12, value: ContainerTypes.PAGE_BREAK, name: 'Page Break' },
    ];
};

export const getAllContainerLayouts = () => {
    return [
        { id: 1, value: ContainerLayouts.VERTICAL, name: 'Vertical' },
        { id: 2, value: ContainerLayouts.HORIZONTAL, name: 'Horizontal' },
    ];
};

export const getAllVerticalAlignments = () => {
    return [
        { id: 1, value: VerticalAlignments.TOP, name: 'Top' },
        { id: 2, value: VerticalAlignments.BOTTOM, name: 'Bottom' },
    ];
};

export const getAllHorizontalAlignments = () => {
    return [
        { id: 1, value: HorizontalAlignments.LEFT, name: 'Right' },
        { id: 2, value: HorizontalAlignments.RIGHT, name: 'Left' },
    ];
};

export const getAllFontSizes = () => {
    const sizes = [10, 12, 14, 16, 18, 24, 32, 36, 48, 60, 72, 96];
    const fontSizes = [];
    sizes.forEach((size) => {
        fontSizes.push({ name: size, value: size });
    });
    return fontSizes;
};

export const getAllDynamicFields = (formulas, fonts, parentTemplates) => {
    return [
        { name: 'name', label: 'Name', fieldType: AttributeInputTypes.INPUT_TEXT, placeholder: 'Enter element name' },
        { name: 'description', label: 'Description', fieldType: AttributeInputTypes.LONG_INPUT_TEXT, placeholder: 'Enter element description' },
        {
            name: 'layout',
            label: 'Layout',
            fieldType: AttributeInputTypes.DROP_DOWN,
            placeholder: 'Select layout type',
            options: getAllContainerLayouts(),
            types: [ContainerTypes.COVER_1, ContainerTypes.COVER_2, ContainerTypes.COVER_3, ContainerTypes.COVER_4, ContainerTypes.MAIN, ContainerTypes.CONTAINER],
        },
        {
            name: 'parent_id',
            label: 'Parent Element',
            fieldType: AttributeInputTypes.DROP_DOWN,
            placeholder: 'Select a parent element',
            options: parentTemplates,
            optionLabel: 'type',
            types: [ContainerTypes.TEXT, ContainerTypes.OL, ContainerTypes.UL, ContainerTypes.IMAGE, ContainerTypes.CONTAINER],
        },
        { name: 'image', label: 'Image Upload', fieldType: 'ImageUpload', types: [ContainerTypes.IMAGE] },
        {
            name: 'formula_id',
            label: 'Formula',
            fieldType: AttributeInputTypes.DROP_DOWN,
            placeholder: 'Select a formula',
            options: formulas ?? [],
            types: [ContainerTypes.CONTAINER],
        },
        {
            name: 'font',
            label: 'Font',
            fieldType: AttributeInputTypes.DROP_DOWN,
            placeholder: 'Select a font type',
            options: fonts ?? [],
            types: [ContainerTypes.TEXT, ContainerTypes.OL, ContainerTypes.UL],
        },
        {
            name: 'fontSize',
            label: 'Font Size',
            fieldType: AttributeInputTypes.DROP_DOWN,
            placeholder: 'Select a font size',
            options: getAllFontSizes(),
            types: [ContainerTypes.TEXT, ContainerTypes.OL, ContainerTypes.UL],
        },
        {
            name: 'valign',
            label: 'Vertical Alignment',
            fieldType: AttributeInputTypes.DROP_DOWN,
            placeholder: 'Select vertical alignment',
            options: getAllVerticalAlignments(),
            types: [ContainerTypes.TEXT, ContainerTypes.OL, ContainerTypes.UL, ContainerTypes.IMAGE],
        },
        {
            name: 'halign',
            label: 'Horizontal Alignment',
            fieldType: AttributeInputTypes.DROP_DOWN,
            placeholder: 'Select horizontal alignment',
            options: getAllHorizontalAlignments(),
            types: [ContainerTypes.TEXT, ContainerTypes.OL, ContainerTypes.UL, ContainerTypes.IMAGE],
        },
        // {
        //     name: 'margin',
        //     label: 'Margin',
        //     fieldType: AttributeInputTypes.NUMBER,
        //     placeholder: 'Input element margin value',
        //     types: [ContainerTypes.TEXT, ContainerTypes.OL, ContainerTypes.UL, ContainerTypes.IMAGE],
        // },
        {
            name: 'text',
            label: 'Content',
            fieldType: AttributeInputTypes.LONG_INPUT_TEXT,
            placeholder: 'Input content value',
            types: [ContainerTypes.TEXT, ContainerTypes.OL, ContainerTypes.UL],
        },
        // Only text input have been taken into consideration at the moment, others are still to be added
    ];
};

export const getValidationMessageByRule = (ruleCode, value) => {
    switch (ruleCode) {
        case ValidationRules.IS_NUMERIC:
            return 'Attribute value must be numeric';
        case ValidationRules.MINIMUM_VALUE:
            return `Minimum value of attribute is ${value}`;
        case ValidationRules.MAXIMUM_VALUE:
            return `Maximum value of attribute cannot exceed  ${value}`;
        case ValidationRules.MINIMUM_LENGTH:
            return `Minimum length of attribute is ${value} characters`;
        case ValidationRules.MAXIMUM_LENGTH:
            return `Maximum length of attribute cannot exceed ${value} characters`;
    }
};
